// routes
import AssessmentIcon from '@mui/icons-material/Assessment';
import PaymentIcon from '@mui/icons-material/Payment';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

import { PATH_DASHBOARD } from '../../../routes/paths';
import { useAuthContext } from '../../../auth/useAuthContext';

// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

const navConfig = [
  // GENERAL
  {
    subheader: 'general',
    items: [
      { title: 'dashboard', path: PATH_DASHBOARD.general.dachboard, icon: ICONS.analytics },
      {
        title: 'Invoices',
        path: PATH_DASHBOARD.assinvoice.list,
        icon: ICONS.invoice,
      },
      {
        title: 'Assesments',
        path: PATH_DASHBOARD.assesment.list,
        icon: <AssessmentIcon />,
      },
      {
        title: 'Reports',
        path: PATH_DASHBOARD.report.list,
        icon: ICONS.menuItem,
      },
      {
        title: 'Payments',
        path: PATH_DASHBOARD.payment.list,
        icon: <PaymentIcon />,
      },
    ],
  },
  // MANAGEMENT
  {
    subheader: 'management',
    items: [
      {
        title: 'Staff',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          { title: 'create', path: PATH_DASHBOARD.user.new },
          { title: 'list', path: PATH_DASHBOARD.user.list },
        ],
      },
      {
        title: 'client',
        path: PATH_DASHBOARD.client.root,
        icon: ICONS.user,
        children: [
          { title: 'Create Client', path: PATH_DASHBOARD.client.new },
          { title: 'list', path: PATH_DASHBOARD.client.list },
        ],
      },
      {
        title: 'calendar date block',
        path: PATH_DASHBOARD.calendar,
        icon: ICONS.calendar,
        children: [{ title: 'calendar', path: PATH_DASHBOARD.calendar }],
      },
      {
        title: 'Rating Chart',
        path: PATH_DASHBOARD.graph.root,
        icon: ICONS.analytics,
        children: [
          { title: 'Enter Inputs', path: PATH_DASHBOARD.graph.new },
          { title: 'list', path: PATH_DASHBOARD.graph.list },
        ],
      },
      {
        title: 'Site Appointments',
        path: PATH_DASHBOARD.sitebooking.list,
        icon: <EventAvailableIcon />,
      },
    ],
  },
];

const navConfigNonAdmin = [
  // GENERAL
  {
    subheader: 'general',
    items: [
      { title: 'dashboard', path: PATH_DASHBOARD.general.dachboard, icon: ICONS.analytics },
      {
        title: 'Assesments',
        path: PATH_DASHBOARD.assesment.list,
        icon: <AssessmentIcon />,
      },
      {
        title: 'Reports',
        path: PATH_DASHBOARD.report.list,
        icon: ICONS.menuItem,
      },
    ],
  },
  // MANAGEMENT
  {
    subheader: 'management',
    items: [

      {
        title: 'Mark your availability',
        path: PATH_DASHBOARD.riskcalendar,
        icon: ICONS.calendar,
        children: [{ title: 'Calendar', path: PATH_DASHBOARD.riskcalendar }],
      },

      {
        title: 'Site Appointments',
        path: PATH_DASHBOARD.sitebooking.list,
        icon: <EventAvailableIcon />,
      },
    ],

    
  },
];

// Export both the configs and the hook
export { navConfig, navConfigNonAdmin };

export default function useNavConfig() {
  const { user } = useAuthContext();
  return user?.role === 'SuperAdmin' ? navConfig : navConfigNonAdmin;
}